import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule, routes} from './app-routing.module';
import {AppComponent} from './app.component';
import {RegistrationComponent} from "./registration/registration.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoginComponent} from './login/login.component';
import {HttpClientModule} from "@angular/common/http";
import {SharedComponent} from './shared/shared.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {SidebarComponent} from './layouts/sidebar/sidebar.component';
import {HeaderComponent} from './layouts/header/header.component';
import {RememberMeGuard} from "./guards/remember-me.guard";
import {AuthGuard} from "./guards/auth.guard";
import {JWT_OPTIONS, JwtHelperService, JwtModule} from "@auth0/angular-jwt";
import {AddQuizComponent} from './quiz/add-quiz/add-quiz.component';
import {AngularEditorModule} from "@kolkov/angular-editor";
import {TestConfigurationComponent} from './quiz/test-configuration/test-configuration.component';
import {QuestionManagerComponent} from './quiz/question-manager/question-manager.component';
import {AddQuizGuard} from "./guards/add-quiz.guard";
import {AddQuestionComponent} from './quiz/question-manager/add-question/add-question.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatRadioModule} from "@angular/material/radio";
import {OtherSettingsComponent} from "./quiz/other-settings/other-settings.component";
import {MatIconModule} from "@angular/material/icon";
import {MatSliderModule} from "@angular/material/slider";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatCardModule} from "@angular/material/card";
import {MatInputModule} from "@angular/material/input";
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from "@angular/material/menu";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatButtonModule} from "@angular/material/button";
import {ResultsTableComponent} from "./quiz/results-table/results-table.component";
import {StartPageComponent} from './quiz/start-page/start-page.component';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {CustomSnackbarComponent} from './quiz/other-settings/custom-snackbar/custom-snackbar.component';
import {ExamComponent} from './exam/exam.component';
import {
  CustomSnackbarErrorsComponent
} from './quiz/question-manager/custom-snackbar-errors/custom-snackbar-errors.component';
import {QuizDialogComponent} from './quiz/quiz-dialog/quiz-dialog.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {FormatTimePipe} from "./util/format-time.pipe";
import {RespondentResultComponent} from "./quiz/respondent-result/respondent-result.component";
import {
  QuizRespondentValidationComponent
} from './quiz/quiz-respondent-validation/quiz-respondent-validation.component';
import {ResultsDatabaseComponent} from './results-database/results-database.component';
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {ResultDialogComponent} from './result-dialog/result-dialog.component';
import {RespondentMonitoringComponent} from './quiz/respondent-monitoring/respondent-monitoring.component';
import {WarningSnackbarComponent} from './exam/warning-snackbar/warning-snackbar.component';
import {QuizModalComponent} from './quiz/quiz-modal/quiz-modal.component';
import {QuizCategoryComponent} from './quiz/quiz-category/quiz-category.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {MatSortModule} from "@angular/material/sort";
import {MatSelectModule} from "@angular/material/select";

import {LandingComponent} from "./landing/landing.component";
import {FooterComponent} from "./landing/footer/footer.component";
import {HeadingComponent} from "./landing/heading/heading.component";
import {MatDividerModule} from "@angular/material/divider";
import {MatListModule} from "@angular/material/list";
import {MainLayoutComponent} from './main-layout/main-layout.component';
import {QuizBinaryToggleComponent} from './layouts/quiz-binary-toggle/quiz-binary-toggle.component';
import {PaginatorComponent} from "./paginator/paginator.component";
import {QuizButtonToggleGroupComponent} from "./layouts/quiz-button-toggle-group/quiz-button-toggle-group.component";
import {ProfileSettingsComponent} from "./profile-settings/profile-settings.component";
import {
  PersonalInformationEditCardComponent
} from "./profile-settings/layouts/personal-information-edit-card/personal-information-edit-card.component";
import {ProfileMenuComponent} from "./profile-settings/layouts/profile-menu/profile-menu.component";
import {
  ProfilePersonalInformationComponent
} from "./profile-settings/pages/profile-personal-information/profile-personal-information.component";
import {
  ProfilePaymentMethodComponent
} from "./profile-settings/pages/profile-payment-method/profile-payment-method.component";
import {
  ProfileSubscriptionHistoryComponent
} from "./profile-settings/pages/profile-subscription-history/profile-subscription-history.component";
import {ProfileMyPlanComponent} from "./profile-settings/pages/profile-my-plan/profile-my-plan.component";
import {
  ProfileSubscriptionCardComponent
} from "./profile-settings/layouts/profile-subscription-card/profile-subscription-card.component";
import {MatTabsModule} from "@angular/material/tabs";
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { ManageSubscriptionComponent } from './subscriptions/manage-subscription/manage-subscription.component';
import { GenericSearchComponent } from './generic-search/generic-search.component';
import { ResultsDatabaseFilterComponent } from './results-database/results-database-filter/results-database-filter.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    LoginComponent,
    SharedComponent,
    ForgotPasswordComponent,
    SidebarComponent,
    HeaderComponent,
    AddQuizComponent,
    TestConfigurationComponent,
    QuestionManagerComponent,
    AddQuestionComponent,
    OtherSettingsComponent,
    ResultsTableComponent,
    OtherSettingsComponent,
    StartPageComponent,
    CustomSnackbarComponent,
    ExamComponent,
    CustomSnackbarErrorsComponent,
    QuizDialogComponent,
    RespondentResultComponent,
    FormatTimePipe,
    QuizDialogComponent,
    QuizRespondentValidationComponent,
    ResultsDatabaseComponent,
    ResultDialogComponent,
    RespondentMonitoringComponent,
    WarningSnackbarComponent,
    QuizModalComponent,
    QuizCategoryComponent,
    SpinnerComponent,
    LandingComponent,
    FooterComponent,
    HeadingComponent,
    MainLayoutComponent,
    PaginatorComponent,
    GenericSearchComponent,
    ResultsDatabaseFilterComponent,
    QuizBinaryToggleComponent,
    PaginatorComponent,
    QuizButtonToggleGroupComponent,
    ProfileSettingsComponent,
    PersonalInformationEditCardComponent,
    ProfileMenuComponent,
    ProfilePersonalInformationComponent,
    ProfilePaymentMethodComponent,
    ProfileSubscriptionHistoryComponent,
    ProfileMyPlanComponent,
    ProfileSubscriptionCardComponent,
    PaginatorComponent,
    ContactUsComponent,
    ProfileSubscriptionCardComponent,
    SubscriptionsComponent,
    ManageSubscriptionComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    JwtModule,
    AngularEditorModule,
    BrowserAnimationsModule,
    MatRadioModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatPaginatorModule,
    MatDividerModule,
    MatListModule,
    MatTabsModule
  ],
  providers: [RememberMeGuard, AuthGuard, AddQuizGuard, {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
    JwtHelperService],
  bootstrap: [AppComponent]

})
export class AppModule {
}
